module.exports = __webpack_public_path__ + "img/KIROV.d24778c3.png";